<template>
    <!-- <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" data-testid="directions-24" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Search Filter</ion-title>
        <ion-buttons slot="end">
            <ion-button @click="reset">
                <span>Reset</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar> -->

    <div class="main_wrapper ion-padding">
        <!-- <div class="search-bar">
            <el-input data-testid="directions-25" v-model="selectedValues.text" class="job-board__search"
                placeholder="Search" clearable @clear="clearText">
                <template #prefix>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
                            stroke="#484848" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M22 22L20 20" stroke="#484848" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </template>
            </el-input>
            <button class="filter-button">
                <img src="@/assets/img/job-seeker/setting-active.svg" />
            </button>
        </div> -->
        <el-button class="reset-button" @click="reset">Reset</el-button>
        <div v-if="loading">
            <JobListingFilterSkeleton :skeletonCount="1" />
        </div>
        <div v-else>
            <div v-if="isFilterOptionsVisible" class="filter-options">
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Type</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(type, index) in jobTypes" :key="index">
                            <input data-testid="directions-26" type="radio" name="type" :id="'jobType-' + index"
                                v-model="selectedValues.jobType" :value="type.title">
                            <label :for="'jobType-' + index">{{ type.title }}</label>
                        </div>
                    </div>
                </div>
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Role</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(platformRole, index) in platformRoles" :key="index">
                            <input data-testid="directions-78-1" type="radio" name="platform_role" :id="'platformRole-' + index"
                                v-model="selectedValues.platformRole" :value="platformRole.slug">
                            <label :for="'platformRole-' + index">{{ platformRole.name }}</label>
                        </div>
                    </div>
                </div>
                <div class="filter-type">
                    <h3 class="filter-title">Filter by Job Location</h3>
                    <!-- <div class="filter-item" v-if="isAustralia">
                        <div class="filter-select" v-for="(location, index) in jobLocations" :key="index">
                            <input data-testid="directions-27" type="radio" name="location" :id="'location-' + index"
                                v-model="selectedValues.jobLocation" :value="location.alphaCode">
                            <label :for="'location-' + index">{{ location.name }}</label>
                        </div>
                    </div> -->
                    <div class="filter-item el-input">
                        <vue-google-suburb-autocomplete 
                            data-testid="directions-102" 
                            id="map" 
                            classname="el-input__inner"
                            v-model="selectedValues.jobLocation"
                            placeholder="Job Location" 
                            v-on:placechanged="updateAddressData"
                            @keyup="setAddress"
                            :initial-location="selectedValues.jobLocation"
                            :country="countryArray"
                            :key="addressComponent"
                        />
                    </div>
                </div>
                <div class="filter-type">
                    <h3 class="filter-title">Tagged Skills</h3>
                    <div class="filter-item">
                        <div class="filter-select" v-for="(skill, index) in taggedSkills" :key="index">
                            <input data-testid="directions-28" type="checkbox" name="tagged-skills"
                                :id="'skill-' + index" v-model="selectedValues.taggedSkills" :value="skill.name">
                            <label :for="'skill-' + index">{{ skill.name }}</label>
                        </div>
                    </div>
                </div>
            </div>
            <el-form-item class="button_submit mb0">
                <el-button class="submit" type="blue" data-testid="directions-29" @click="goSearch">
                    Apply
                </el-button>
            </el-form-item>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
import { VueGoogleSuburbAutocomplete } from "@/components/components";

const $store = useStore();
const $router = useRouter();
const isFilterOptionsVisible = ref(true);
const currentRouteName = ref(null);
const addressComponent = ref(0);
const isAustralia = isAustraliaRegion();
const emit = defineEmits(['update:modalPreviousApplicationVisible']);

import JobListingFilterSkeleton from "@/components/JobListingSkeleton/JobListingFilterSkeleton.vue";
const selectedValues = ref({
    text: '',
    jobType: '',
    jobLocation: '',
    platformRole: '',
    taggedSkills: [],
});

const jobTypes = ref([]);
const platformRoles = ref([]);
const jobLocations = ref([]);
const taggedSkills = ref([]);
const loading = ref(false);

// Function to reset filters
const reset = () => {
    localStorage.removeItem('jobPosterPreviousFilterObject');
    selectedValues.value = {
        text: '',
        jobType: '',
        jobLocation: '',
        platformRole: '',
        taggedSkills: [],
    };
    addressComponent.value += 1;
}

// Function to navigate back
// const goBack = () => {
//     currentRouteName.value = $router.currentRoute.value.name;
//     console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
//     $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);

//     $router.push({
//         name: "job_poster",
//     });
// };

// Function to perform search
const goSearch = () => {
    // Save selected values to local storage
    localStorage.setItem('jobPosterPreviousFilterObject', JSON.stringify(selectedValues.value));

    // Perform search action
    currentRouteName.value = $router.currentRoute.value.name;
    console.log("🚀 ~ setup ~ currentRouteName.value:", currentRouteName.value)
    $store.dispatch('PREVIOUS_ROUTE_NAME', currentRouteName.value);
    // $router.push({
    //     name: "job_poster",
    // });
    emit('update:modalPreviousApplicationVisible', false);
    emit("job-previous-application-filter");
};

// const clearText = () => {
//     console.log('clear text')
//     selectedValues.value.text = '';
//     // Update local storage to remove only the 'text' property from 'jobPosterPreviousFilterObject'
//     const storedValues = JSON.parse(localStorage.getItem('jobPosterPreviousFilterObject'));
//     if (storedValues) {
//         delete storedValues.text;
//         localStorage.setItem('jobPosterPreviousFilterObject', JSON.stringify(storedValues));
//     }
// };

const jobListingAttributesForFilter = () => {
    loading.value = true;
    (async () => {
        const existingCvResponse = await $store.dispatch("GET_JOB_POSTER_LISTINGS");
        loading.value = false;
        jobTypes.value = existingCvResponse.data.type;
        platformRoles.value = existingCvResponse.data.platformRoles;
        if(isAustralia) {
            jobLocations.value = existingCvResponse.data.location;
        }
        taggedSkills.value = existingCvResponse.data.popularSkills;
    })();
}

const updateAddressData = (addressData) => {
    selectedValues.jobLocation = '';
    selectedValues.value.jobLocation = addressData.formatted_address;
};

const setAddress = () => {
    selectedValues.value.jobLocation = '';
};

// Restore selected values from local storage on component mount
onMounted(() => {
    const storedValues = localStorage.getItem('jobPosterPreviousFilterObject');
    if (storedValues) {
        selectedValues.value = JSON.parse(storedValues);
    }

    jobListingAttributesForFilter()
});

</script>
